import React, { useCallback, useEffect } from 'react';
import ChatOpener from 'modules/Chat/ChatOpener';
import ChatList from 'modules/Chat/ChatList';
import ChatNewConversation from 'modules/Chat/ChatNewConversation';
import ChatConversation from 'modules/Chat/ChatConversation';
import { useAuth } from 'hooks/useAuth/useAuth';
import { CHAT_ROUTES } from 'utils/constants/chat';
import { useConversation } from 'hooks/useConversation/useConversation';

const Chat = ({ className }) => {
  const { profile, termsAccepted } = useAuth();
  const { chatRoute, cleanState } = useConversation();

  useEffect(() => {
    if (!profile) {
      cleanState();
    }
  }, [profile, cleanState]);

  const renderChat = useCallback(() => {
    if (!termsAccepted) return null;

    switch (chatRoute) {
      case CHAT_ROUTES.CLOSED:
        return <ChatOpener />;
      case CHAT_ROUTES.CONVERSATIONS_LIST:
        return <ChatList />;
      case CHAT_ROUTES.NEW_CONVERSATION:
        return <ChatNewConversation />;
      case CHAT_ROUTES.CONVERSATION:
        return <ChatConversation />;
      default:
        return <ChatOpener />;
    }
  }, [termsAccepted, chatRoute]);

  return (
    <div className={className} data-testid="chat">
      <div className="chat" data-testid="chat__container">
        {renderChat()}
      </div>
    </div>
  );
};
export default Chat;
